import React from 'react';
import { TDeviceIssue, TDeviceIssueType } from 'app/types/deviceIssue';
import { DeviceIssueCard } from './DeviceIssueCard';
import { View } from 'react-native';

export interface DeviceIssueCardStackProps {
  issues: TDeviceIssue[];
  onSelectIssue: (issueType: TDeviceIssueType) => void;
}

export const DeviceIssueCardStack: React.FC<DeviceIssueCardStackProps> = ({ issues, onSelectIssue }) => (
  <View className="flex gap-4 mb-4">
    {issues.filter(issue => issue.active).map(issue => (
      <DeviceIssueCard
        key={issue.issueType}
        issueType={issue.issueType}
        onPress={() => onSelectIssue(issue.issueType)}
      />
    ))}
  </View>
);
